<template lang="pug">
#wrap_sub
  .sub_right
    .content_desc
      .in
        article#bo_v.inner
          section#bo_v_atc
            .info
              ul
                li
                  h3 매장명
                  p {{ resData.name }}
                li
                  h3 주소
                  p {{ resData.addr }}
                li
                  h3 전화번호
                  p {{ resData.mobile }}
                li.widelist(v-if="resData.memo")
                  h3 메모
                  p.store-memo {{ resData.memo }}
                li.imglist(v-if="resData.firstFile || resData.secondFile")
                  h3 사진
                  img.shop_img(:src="resData.firstFile" alt='' v-if="resData.firstFile")
                  img.shop_img(:src="resData.secondFile" alt='' v-if="resData.secondFile")
            .bo_v_bot
              .bo_v_com
                li
                  a(@click='$_goTo({name: "store"})').btn_b01.btn_list 목록
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      param: this.$route.params,
      resData: {},
    };
  },
  computed: {
    ...mapGetters(['userAccToken', 'lan']),
  },
  methods: {
    async getData() {
      await this.$_axios('GET', 'board/store/detail', {
        id: this.param.id,
        nation: this.lan,
      }).then(res => {
        if (res.status === 204) {
          alert('존재하지 않는 글입니다.');
          this.$_goTo({ name: 'store' });
        }
        this.resData = res.data.res[0];
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
@import '../../assets/css/store.css';
.shop_img {
  width: 30%;
}
#bo_v_atc .info ul li.imglist {
  border-bottom: 1px solid #ddd;
  width: 100%;
}
.bo_v_bot {
  margin-top: 60px;
}
.bo_v_com {
  margin: 20px 0;
  float: right;
}
#bo_v_atc .info ul li.widelist {
  width: 100%;
  display: flex;
  font-size: 18px;
}
.bo_v_com > li {
  position: relative;
  float: left;
  margin-left: 5px;
}
#bo_v a.btn_b01 {
  border: 1px solid #aaa;
}
#bo_v a.btn_list {
  padding: 10px 25px;
  background: #666;
  border-color: #666;
  color: #fff;
}
a.btn_b02,
.btn_b02 {
  background: #333;
  padding: 10px 25px;
}
a.btn_b02:hover,
.btn_b02:hover {
  background: #f7941e;
}
#bo_v_atc {
  min-height: 200px;
  height: auto !important;
  height: 200px;
  padding: 100px 0 50px;
}
a.btn_b01,
.btn_b01 {
  width: 100%;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
}
a.btn_b02,
.btn_b02 {
  width: 100%;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
}
#bo_v_atc .info ul {
  display: flex;
  flex-wrap: wrap;
}
#bo_v_atc .info ul li {
  display: flex;
  width: 50%;
  font-size: 18px;
}
#bo_v_atc .info ul li:first-child {
  width: 100%;
  border-top: 1px solid #ddd;
}
#bo_v_atc .info ul li h3 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;
  background: #333;
  color: #fff;
  text-align: center;
  border-bottom: 1px solid #666;
  padding: 15px 0;
}
#bo_v_atc .info ul li p {
  display: flex;
  align-items: center;
  width: calc(100% - 130px);
  padding-left: 20px;
  border-bottom: 1px solid #ddd;
  padding: 15px 0 15px 20px;
}

@media (max-width: 1024px) {
  #bo_v_atc .info ul li {
    font-size: 16px;
  }
  #bo_v_atc .info ul li h3 {
    width: 110px;
    padding: 10px 0;
  }
  #bo_v_atc .info ul li p {
    width: calc(100% - 110px);
  }
}
@media (max-width: 768px) {
  #bo_v_atc .info ul {
    display: block;
  }
  #bo_v_atc .info ul li {
    width: 100%;
    font-size: 14px;
  }
}
/* .sub_right {
  padding: 0;
} */
</style>
